import { Crown, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocale } from "../App";

export function VipPromptModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation();
  const lang = useLocale();
  const navigate = useNavigate();
  if (!open) return null;
  return (
    <div className="vip-modal-backdrop" role="dialog" aria-modal="true" aria-label={t("vipPromptTitle")} onMouseDown={(event)=>{if(event.target===event.currentTarget)onClose();}}>
      <section className="vip-modal-card">
        <button className="vip-modal-close" type="button" aria-label={t("closePhoto")} onClick={onClose}><X/></button>
        <span><Crown/></span>
        <h2>{t("vipPromptTitle")}</h2>
        <p>{t("vipRequired")}</p>
        <button className="primary" type="button" onClick={()=>navigate(`/${lang}/account`)}>{t("vipUnlock")}</button>
      </section>
    </div>
  );
}
